import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PageTitle from '../../atoms/PageTitle';
import { getValueByTarget, VehiclesOptionCount } from '../../../utils/parse';
import {
    BookingProducts,
    ConfirmEstimateDescription,
    ContractPeriodOptions,
    NumberOfVehiclesOptions,
    PassengerOptions,
    PurposeOfContractOptions,
    RoleOfVehiclesOptions,
    UsageTimeOptions,
    CarAmountOptions,
    InsuranceOptions,
    PassengerPersonOptions,
    UsageTimeOptionsAnnual,
    UsageTimeOptionsMonthly,

} from '../../../utils/EstimateFormData';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ListBox from '../../atoms/ListBox';

import useCheckPC from '../../../hooks/useCheckPC';
import ListWithBullet from '../../atoms/ListWithBullet';
import { transFormWon, transFormWon2 } from '../../../utils/numbers';
import { getEstimateCookieDataAndDecrypt, isChkAddressSeoul } from '../../../lib/Util';

import moment from 'moment';
import vutler_dojang from '../../../styles/img/vutler_dojang.png'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import qs from 'qs'
import Button from '../../atoms/Button';
import { isNullOrUndef } from 'chart.js/helpers';

/**
 * 견적 확인 페이지
 * name : confirmEstimate
 * */

const EstimateDownloadDataUrlAdmin = () => {
    const navigate = useNavigate();
    const { isPC } = useCheckPC();
    const { BookingOption, ContractMonthArray } = useSelector((state) => state);
    const [loading, setLoading] = useState(false)
    const [firstProcess, setFirstProcess] = useState(false)
    const [UserName, SetUserName] = useState('')

    const [ConfirmEstimateDescription2, SetConfirmEstimateDescription2] = useState([
        '본 견적 내 항목은 모두 VAT포함입니다.',
        '실탑승자 5인까지를 기준으로 한 견적이며, 6인 이상 이용이 필요하실 경우 컨시어지로 문의 바랍니다.',
        `<span style="color: red;">구입 시간 모두 소진 시 추가 구입이 가능합니다.</span>`,
        '본 견적서 내 포함되지 않은 항목이라도 실제 서비스 이용에 따라 할증 요금이 사전 안내 후 청구될 수 있습니다.',
    ])
    /** 차량 옵션 **/
    const [vehicleOption, setVehicleOption] = useState([]);
    
    
    const [ProductInfo, setProductInfo] = useState({
        Title: '',
        FileName: ``,
        UsageUnit: 0,
        UsageUnitStr: '',
        ContractTypeDay: 0,
        ContractTypeHour: 0,
        ContractOneDayAvaliableHour: 0,
        BasicHour: 0,
        MmHourPrice: 0,
        PromotionDiscountPercent: 0,
        ProductAmount: 0,
        PromotionDiscountAmount: 0,
        PromotionAnnualMonth: 0,
		PromotionPrePaidTicket: 0
    });
    const [totalAmount, setTotalAmount] = useState(0)
    const [productTitle, setProductTitle] = useState('')
    const [saveDataUrl, setSaveDataUrl] = useState(null)
    const [captureSize, setCaptureSize] = useState({ width: 762, height: 1069 })

    const [serviceArea, setServiceArea] = useState([])
    const [periodOfContract, setPeriodOfContract] = useState([]);
    const [Promotion, setPromotion] = useState([]);
    const [contractTerms2, setContractTerm2] = useState([]);
    const [view, setView] = useState(null);
    const [subscription, setSubscription] = useState([]);
    const [usageTime, setUsageTime] = useState([]);

    const sleep = (time) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, time);
        })
    }

    const print = async () => {
        const estimateElement = document.querySelector('#estimate_form2');
        const elementWidth = estimateElement?.scrollWidth ?? 762
        const elementHeight = estimateElement?.scrollHeight ?? 1200

        const canvas = await html2canvas(estimateElement, {
            width: elementWidth,
            height: elementHeight,
            scale: 2,
            useCORS: true,
            scrollY: -window.scrollY
        })
        const dataUrl = canvas.toDataURL('image/png')
        setSaveDataUrl(dataUrl)
        setCaptureSize({
            width: canvas.width,
            height: canvas.height
        })

        return dataUrl
    }




    useEffect(() => {
        const qsdata = qs.parse(document.location.search, { ignoreQueryPrefix: true })?.qsdata ?? ''
        const dataonly = qs.parse(document.location.search, { ignoreQueryPrefix: true })?.dataonly ?? 'false'
        
        const data = JSON.parse(decodeURIComponent(atob(qsdata)))

        SetUserName(data?.UserName)
        setProductTitle(data?.ProductTitle)
        setSubscription(data?.ProductName)
        setVehicleOption(data?.OptionInfo)
        setPeriodOfContract(data?.PeriodOfContract)
        setTotalAmount(data?.AllFee)
        setPromotion(data?.Promotion)
        setProductInfo(data?.ProductInfo)
        // UsageTimeOptionsAnnual
        // UsageTimeOptions

        /** 이용 지역 **/
        const updatedServiceArea = [
            {
                title: `차고지: 
          ${BookingOption?.contractTerms1?.serviceArea?.departure?.address1} 
          ${BookingOption?.contractTerms1?.serviceArea?.departure?.address2}`
            }
        ].filter(Boolean);
        setServiceArea(updatedServiceArea)

        /** 이용 정보 **/
        const updatedContractTerms2 = [
            { title: `이용 목적: ${getValueByTarget(PurposeOfContractOptions, BookingOption?.contractTerms2?.purposeOfContract, 'title')}` },
            { title: `탑승자: ${getValueByTarget(PassengerOptions, BookingOption.contractTerms2.passenger, 'title')}` },
            { title: `차량 번호 1: ${BookingOption.contractTerms2.vehicleName1}` },
            { title: `차량 번호 2: ${BookingOption.contractTerms2.vehicleName2}` },
        ]

        if (VehiclesOptionCount(BookingOption?.vehicleOption?.numberOfVehicles) === 3) {
            updatedContractTerms2.push({ title: `차량 번호 3: ${BookingOption.contractTerms2.vehicleName3}` })
        }

        setContractTerm2(updatedContractTerms2)


        const seoulResult = isChkAddressSeoul(BookingOption?.contractTerms1?.serviceArea?.departure?.address1)
        const addedArray = [];
        // if (!seoulResult) addedArray.push('예상 출발지/종료지가 서울 이외일 경우, 지역할증이 부과될 수 있습니다.')
        addedArray.push(`본 견적서의 내용은 ${moment().add(1, 'months').format('yyyy년 MM월 DD일')}까지 유효합니다.`)

        // 충전권 프로모션 
        if (data?.ProductInfo?.PromotionPrePaidTicket && data?.ProductInfo?.PromotionPrePaidTicket >= 1) {
            const hour = data?.ProductInfo?.PromotionPrePaidTicket
            addedArray.push(`<span style="color: red;">충전권 ${hour}시간 (${transFormWon(hour*30000)} 상당) 증정</span>`)
        }

        SetConfirmEstimateDescription2([
            ...ConfirmEstimateDescription2,
            ...addedArray
        ])
        setLoading(true)

        ///estimate_form
        const ProcessFunc = async () => {
            if (!firstProcess) {
                await sleep(2000)
                let imgdata = await print()
                
                if (dataonly === 'true') {
                    localStorage.setItem('estimate_img', imgdata.replace('data:image/png;base64,', ''))
                    localStorage.setItem('estimate_img_processed', false)
                }
                
            }
            setFirstProcess(true)
        }
        ProcessFunc()

    }, [BookingOption])

    useEffect(() => {
        // console.log('helloworld');
    }, [loading])

    const Download = () => {
        try {
            let pdf = new jsPDF('p', 'mm', 'a3')
            const pageWidth = pdf.internal.pageSize.getWidth()
            const pageHeight = pdf.internal.pageSize.getHeight()
            const horizontalMargin = 12
            const verticalMargin = 8

            const aspectRatio = captureSize.height / captureSize.width

            const availableWidth = pageWidth - horizontalMargin * 2
            const availableHeight = pageHeight - verticalMargin * 2

            let imgWidth = availableWidth
            let imgHeight = imgWidth * aspectRatio

            if (imgHeight > availableHeight) {
                imgHeight = availableHeight
                imgWidth = imgHeight / aspectRatio
            }

            const shrinkRatio = 0.9
            imgWidth *= shrinkRatio
            imgHeight *= shrinkRatio

            const positionX = (pageWidth - imgWidth) / 2
            const positionY = (pageHeight - imgHeight) / 2

            pdf.addImage(saveDataUrl, 'PNG', positionX, positionY, imgWidth, imgHeight, '', 'MEDIUM')
            // pdf.addImage(imgData, 'PNG', 10, 10, 140, 210)
            pdf.save(ProductInfo?.FileName)
        }
        catch (e) {

        }
    }

    const getPercentDiscountCalc = (BasicAmount, DiscountAmount) => {
        return Math.round(((BasicAmount - DiscountAmount) / BasicAmount) * 100)
    }

    const ComponentProduct = ({ info }) => {
        // 렌더링될 tr의 개수를 계산
        const hasPromotionDiscount = info?.PromotionDiscountPercent >= 1;
        const hasPromotionAnnualMonth = info?.PromotionAnnualMonth >= 1;
        
        // 마지막 tr이 무엇인지 판단
        // 1. 첫 번째만 있으면 → 첫 번째가 마지막
        // 2. 첫 번째 + 두 번째만 있으면 → 두 번째가 마지막
        // 3. 첫 번째 + 세 번째만 있으면 → 세 번째가 마지막
        // 4. 첫 번째 + 두 번째 + 세 번째 모두 있으면 → 세 번째가 마지막
        const isLastRow = {
            first: !hasPromotionDiscount && !hasPromotionAnnualMonth,
            second: hasPromotionDiscount && !hasPromotionAnnualMonth,
            third: hasPromotionAnnualMonth
        };

        // borderBottom 스타일 결정
        const getBorderStyle = (isLast) => isLast ? {} : { borderBottom: 'none' };

        return (<>
            <tr>
                <td style={{ textAlign: 'left', ...getBorderStyle(isLastRow.first) }} dangerouslySetInnerHTML={{ __html: info?.Title }} />
                <td style={getBorderStyle(isLastRow.first)}>{info?.UsageUnit}{info?.UsageUnitStr}</td>
                <td style={getBorderStyle(isLastRow.first)}>{info?.ContractOneDayAvaliableHour}</td>
                <td style={getBorderStyle(isLastRow.first)}>{info?.BasicHour}</td>
                <td style={getBorderStyle(isLastRow.first)}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ textDecoration: 'line-through', color: '#c8c8c8', fontWeight: 600, letterSpacing: '-0.5px' }}>30,000</span>
                        <span style={{ color: '#c8c8c8', fontSize: '12px', letterSpacing: '-0.5px' }}>→</span>
                        <span style={{ fontWeight: 'bold', color: '#1d1d1d', letterSpacing: '-0.5px' }}>{transFormWon2(info?.MmHourPrice)}</span>
                    </div>
                    <div style={{ color: '#ff7a00', fontWeight: 600, fontSize: '12px', textAlign: 'left', letterSpacing: '-0.2px' }}>{getPercentDiscountCalc(30000, info?.MmHourPrice)}% off</div>
                </td>
                <td style={getBorderStyle(isLastRow.first)}>
                    <span style={info?.PromotionDiscountPercent >= 1 ? { textDecoration: 'line-through', color: 'red' } : null} >
                        {transFormWon2(info?.BasicHour * info?.MmHourPrice)}
                    </span>
                </td>
            </tr>

            {hasPromotionDiscount && (
                <tr>
                    <td style={{ color: 'red', textAlign: 'left', ...getBorderStyle(isLastRow.second) }} >DISCOUNT PROMOTION</td>
                    <td style={getBorderStyle(isLastRow.second)}></td>
                    <td style={getBorderStyle(isLastRow.second)}></td>
                    <td style={getBorderStyle(isLastRow.second)}></td>
                    <td style={getBorderStyle(isLastRow.second)}>
                        <div style={{ color: 'red', fontWeight: 600, textAlign: 'left', letterSpacing: '-0.2px' }}>기본 이용료 추가 {info?.PromotionDiscountPercent}% off</div>
                    </td>
                    <td style={getBorderStyle(isLastRow.second)}>{transFormWon2(info?.PromotionDiscountAmount)}</td>
                </tr>
            )}

            {hasPromotionAnnualMonth && (
                <tr>
                    <td style={{ color: 'red', textAlign: 'left', ...getBorderStyle(isLastRow.third) }} >PERIOD OF USE PROMOTION</td>
                    <td style={getBorderStyle(isLastRow.third)}>{info?.PromotionAnnualMonth}개월</td>
                    <td style={getBorderStyle(isLastRow.third)}></td>
                    <td style={getBorderStyle(isLastRow.third)}></td>
                    <td style={getBorderStyle(isLastRow.third)}></td>
                    <td style={getBorderStyle(isLastRow.third)}></td>
                </tr>
            )}
        </>)
    }

    const ComponentOption = ({ optionArr }) => {
        // 최대 옵션 행 개수 (필요시 수정 가능)
        const MAX_OPTION_ROWS = 6;
        
        // 실제 옵션 배열이 없거나 undefined인 경우 빈 배열로 처리
        const safeOptionArr = optionArr || [];
        const actualCount = safeOptionArr.length;
        const emptyRowsCount = Math.max(0, MAX_OPTION_ROWS - actualCount);
        
        return (
            <>
                {/* 실제 옵션 데이터 렌더링 */}
                {safeOptionArr.map((data, idx) => {
                    return (
                        <tr key={idx}>
                            <td style={{ textAlign: 'left', borderBottom: 'none' }} >[OPT] {data?.title}</td>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                            <td style={{ borderBottom: 'none' }}>-</td>
                            <td style={{ borderBottom: 'none' }}>-</td>
                            <td style={{ borderBottom: 'none' }}>
                                <div style={
                                    !isNullOrUndef(data?.discount) ?
                                        { color: 'red', fontWeight: 600, letterSpacing: '-0.2px' } :
                                        null
                                }>
                                    {!isNullOrUndef(data?.discount) ? `-${transFormWon2(data?.discount)}` : transFormWon2(data?.price)}
                                </div>
                            </td>
                            <td style={{ borderBottom: 'none' }}>
                                <div style={
                                    !isNullOrUndef(data?.discount) ?
                                        { color: 'red', fontWeight: 600, letterSpacing: '-0.2px' } :
                                        null
                                }>
                                    {!isNullOrUndef(data?.discount) ? `-${transFormWon2(data?.discount)}` : transFormWon2(data?.price)}
                                </div>
                            </td>
                        </tr>
                    )
                })}
                
                {/* 부족한 만큼 빈 행 추가 (공간 확보) */}
                {Array.from({ length: emptyRowsCount }).map((_, idx) => {
                    return (
                        <tr key={`empty-${idx}`}>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                            <td style={{ borderBottom: 'none' }}>&nbsp;</td>
                        </tr>
                    )
                })}
            </>
        )
    }

    // 
    const ComponentTotalEstimate = ({ TotalAmount }) => {
        return (
            <tr>
                <td style={{ textAlign: 'left', borderTop: '1px solid var(--line)' }} >ESTIMATED TOTAL</td>
                <td style={{ borderTop: '1px solid var(--line)' }}></td>
                <td style={{ borderTop: '1px solid var(--line)' }}></td>
                <td style={{ borderTop: '1px solid var(--line)' }}></td>
                <td style={{ borderTop: '1px solid var(--line)' }}></td>
                <td style={{ borderTop: '1px solid var(--line)' }}>{transFormWon2(TotalAmount)}</td>
            </tr>
        )
    }

    return (
        <>
            <Button
                style={{ width: '150px' }}
                styleType='secondary'
                onClick={() => {
                    Download()
                }}>↓ 견적서 다운로드</Button>
            <div id="estimate_form2" style={{
                padding: '30px 20px',
                width: '800px',
                minHeight: '1069px'
            }}>
                <div className={classNames('booking-wrap2')}>
                    <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '40px' }}>{productTitle} 견적서</div>

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: '18px' }}>{moment().format('yyyy년 MM월 DD일')}</div>
                        <div style={{ textAlign: 'right' }}>
                            <span style={{ display: 'block', padding: '5px 0', fontSize: '18px' }}>{UserName} 고객님</span>
                            <span style={{ display: 'block', padding: '5px 0', fontSize: '18px' }}>아래와 같이 견적서를 발송합니다.</span>
                        </div>
                    </div>

                    <div className={classNames('confirm-booking-wrap2')}>
                        <div className={classNames('confirm-booking-content2')}>
                            <div className={classNames('table-wrap')}>
                                <table>
                                    <thead>
                                        <th></th>
                                        <th>이용단위</th>
                                        <th>1일(건)<br />최소이용시간</th>
                                        <th>기본이용시간</th>
                                        <th>단가<br />(per hour)</th>
                                        <th>금액</th>
                                    </thead>
                                    <tbody>
                                        <ComponentProduct
                                            info={ProductInfo} />
                                        <ComponentOption
                                            optionArr={vehicleOption} />
                                        <ComponentTotalEstimate
                                            TotalAmount={totalAmount} />
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className={classNames('box-light-grey-1 footer-contents2')}>
                            <ul className={classNames('list-style')}>
                                {ConfirmEstimateDescription2.map((item, index) => (
                                    <li key={index}>
                                        <span className={classNames('grey-2')} dangerouslySetInnerHTML={{ __html: item }}>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', marginBottom: '100px' }}>
                            <div style={{ fontSize: '18px' }}>
                                <span style={{ display: 'block', padding: '5px 0', fontSize: '18px', fontWeight: 'bold' }}>주식회사 버틀러</span>
                                <span style={{ display: 'block', padding: '5px 0', fontSize: '18px' }}>서울 강남구 테헤란로 151, 5층</span>
                            </div>
                            <div style={{ fontSize: '18px', textAlign: 'right' }}>
                                <span style={{ display: 'block', padding: '5px 0', fontSize: '18px' }}>463-87-00162</span>
                                <span style={{ display: 'block', padding: '5px 0', fontSize: '18px' }}>이근우</span>
                            </div>
                            <div style={{ textAlign: 'left' }}>
                                <span style={{ display: 'block', fontSize: '18px' }}><img src={vutler_dojang} style={{ width: '80%' }} alt='' /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default EstimateDownloadDataUrlAdmin;